import {DataFetcher} from '@aboutyou/data-fetcher';
import {SkeletonBlock} from '@aboutyou/ui-components';
import React from 'react';
import {GenderSwitchView} from './GenderSwitchView';
import {useGenderSwitchSection} from '../hooks/useGetHeaderBulkSection';
import {styled} from '@linaria/react';

export const GenderSwitch: React.FC<{
  className?: string;
}> = props => (
  <DataFetcher
    request={useGenderSwitchSection()}
    Loading={Skeleton}
    View={GenderSwitchView}
    viewProps={props}
    Error={() => null}
  />
);

const Skeleton = () => {
  return (
    <Wrapper>
      <SkeletonBlock $width="180px" $height="20px" />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  margin-top: 16px;
`;
